import { merge } from 'lodash-es';

import { DEFAULT_DATATABLE_CONFIG } from '../DataTable/constants.js';
import type { DataTableConfig } from '../DataTable/public.api.js';

/**
 * Gets DataTable configuration, merging the default ones with the stringified json config.
 * For the case that there is a conflict property, default would prevail.
 * For the case that there is any parse error, it will return an empty config.
 *
 * @param serializedConfig - stringify json config
 *
 * @returns - DataTableConfig
 */
export function deserializeDataTableConfig(
  serializedConfig: string,
): DataTableConfig {
  try {
    return merge({}, DEFAULT_DATATABLE_CONFIG, JSON.parse(serializedConfig));
    // oxlint-disable-next-line typescript/no-unused-vars
  } catch (error) {
    return DEFAULT_DATATABLE_CONFIG;
  }
}
